import type { FaireProductEntity } from "../../entity_types/product";

export const p_kvdu67c5de: FaireProductEntity = {
  token: "p_kvdu67c5de",
  type: "product",
  name: "The Essentials Pouch",
  brandToken: "b_fbpvksp7qw",
  brandName: "Kōv Essentials (No duties or tariffs for CA+USA)",
  imageUrl:
    "https://cdn.faire.com/fastly/049df26e7700301b60d5b3de19346dbaa0ecc887a142204fdd3600fb7f1b9fff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23eff735c530ce53e8050773b2f700ad1ccb0b15323b6165b6e4c5266be866b3.jpeg",
    "https://cdn.faire.com/fastly/5850b23d520872cc6aebce862990d04a93299aea1afbb5b5660c30a3b797ef2b.jpeg",
  ],
  priceDollars: 20.8,
  description:
    "\nThe Essentials Pouch - designed to hold all your claw clip, make-up and self care essentials⁠. A large zipper pouch with an inner pocket and Creaseless Clip band, made from heavyweight canvas. \n\nThe Essentials Pouch is the perfect all-in-one functional bag to sit on your vanity, throw in your suitcase or take on the go. \n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:46.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
